import React, { useEffect, useState } from 'react';
import { useTable } from 'react-table';
// import data from '../../../static/dummyShiftData.json'
import TimeLineGraph from './TimeLineGraph';
import {
  calculateTimeDifference,
  countCompleteEvents,
  formatTimeStr,
  formatTimeTillMin,
  generateShiftData,
  getFilteredModifiedData,
} from '../../../services/common.utils';
import TimeSeriesChart from './TimeSeriesComponent';
import ActualTimeline from './ActualTimeline';
import ActualTimelineFullSeries from './ActualTimelineFullSeries';
import { ChevronDown, ChevronUp, Eye, EyeIcon, EyeOff } from 'lucide-react';
import ActualTimelineNew from './ActualTimelineNew';

const TableComponent = ({ columns, data, segment_list }) => {
  const {
    getTableProps,
    getTableBodyProps,
    rows,
    headerGroups,
    prepareRow,
  } = useTable({
    columns,
    data,
  });

  // Process the data
  let totalAccruedTime = rows.reduce(
    (total, row) => total + (row.original.seconds_accrued || 0),
    0,
  );
  // Calculate total accrued time
  let totalAcrruedForUnpaid = calculateTimeDifference(
    data[3]?.time_out,
    data[5]?.time_in,
  );
  const totalAccruedTimeNew = totalAccruedTime; //totalAcrruedForUnpaid === '-' ? totalAccruedTime : (totalAccruedTime + totalAcrruedForUnpaid)
  return (
    <div className="table-responsive px-0">
      <table
        {...getTableProps()}
        className="text-black table w-100 ctShiftTable"
      >
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, i) => (
                <th
                  {...column.getHeaderProps()}
                  style={{
                    padding: '5px',
                    borderBottom: 'solid 2px gray',
                    background: 'aliceblue',
                    color: 'black',
                    fontWeight: '500',
                    textAlign: i === 3 ? 'center' : 'left',
                    maxWidth: i === 4 ? 100 : 'auto',
                    fontSize: 12,
                  }}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows?.map(row => {
            prepareRow(row);
            // Determine the background color based on the type_name
            const backgroundColor = (() => {
              switch (row.original.segment_name) {
                case (segment_list[0]).toLowerCase():
                case segment_list[segment_list?.length - 1]:
                  return row.original.color_code;
                case 'rooms cleaning 1':
                case 'rooms cleaning 2':
                case 'rooms cleaning 3':
                case 'rooms cleaning 4':
                  return row.original.color_code;
                case 'break1':
                case 'break2':
                  return row.original.color_code;
                case 'lunch':
                  return row.original.color_code === '#ffffff'
                    ? '#E0346F'
                    : row.original.color_code;
                default:
                  return row.original.color_code;
              }
            })();
            return (
              <tr {...row?.getRowProps()} style={{ backgroundColor }}>
                {row?.cells?.map((cell, i) => (
                  <td
                    className="text-capitalize text-wrap"
                    {...cell?.getCellProps()}
                    style={{
                      padding: '5px 10px', // Adjust padding for compactness
                      textAlign: i === 3 ? 'center' : 'left',
                      maxWidth: i === 4 ? 100 : 'auto',
                      fontSize: '14px', // Optional: Adjust font size for compactness
                    }}
                  >
                    {cell?.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
          {/* Total row */}
          <tr
            style={{
              padding: '5px',
              borderBottom: 'solid 2px gray',
              background: 'aliceblue',
              color: 'black',
              fontWeight: '500',
              fontSize: 12,
            }}
          >
            <td
              colSpan={4}
              style={{ padding: '10px 20px', fontWeight: 'bold' }}
              className="text-primary text-end"
            >
              Total Accrued Time :
            </td>
            <td
              colSpan={2}
              style={{ padding: '10px', fontWeight: 'bold' }}
              className="text-primary"
            >
              {formatTimeStr(totalAccruedTimeNew)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

// const TimelineComponent = ({ data, scheduleData }) => {
//   return <div className='d-flex justify-content-center mt-3'><TimeLineGraph scheduleData={scheduleData} /></div>
// };

const ShiftTable = ({ isPink, ss_is_in, data, setData, currentSegment, segment_list, elapsedTime }) => {
  const userDetailsAll = JSON.parse(localStorage?.getItem('userDetailsAll'));
  let modified_shift_data = generateShiftData(data);
  // console.log(modified_shift_data)
  const userData = JSON.parse(localStorage?.getItem('userDetails')) || {};
  const selectedLoginData = JSON.parse(
    localStorage?.getItem('selectedLoginData'),
  );
  let selectedDataFilter = userData?.filter(
    e =>
      e?.properties_id === parseInt(selectedLoginData?.properties_id) &&
      e?.roles_id === Number(selectedLoginData?.role_id),
  )?.[0];
  let selectedData = userDetailsAll?.user_info
    ? userDetailsAll?.user_info
    : selectedDataFilter;
  let mrrDetails = selectedData?.properties_roles_array?.find(
    e =>
      e?.resources_id === selectedData?.resources_id &&
      e?.properties_id === selectedData?.properties_id,
  );
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'Segment',
        accessor: 'segment_name',
      },
      {
        Header: 'Start Time',
        accessor: 'time_start',
        Cell: ({ value }) => (value ? formatTimeTillMin(value) : '-'),
      },
      {
        Header: 'End Time',
        accessor: 'time_end',
        Cell: ({ value }) => (value ? formatTimeTillMin(value) : '-'),
        // Cell: ({ value, row }) => {
        //   const isCurrentSegment = row.original.segment_name?.toLowerCase() === currentSegment?.toLowerCase();
        //   const endTime = value ? formatTimeTillMin(value) : '-';
        //   return isCurrentSegment ? `${endTime} (${elapsedTime})` : endTime;
        // },
      },
      // {
      //   Header: '',
      //   accessor: 'elapsedTime',
      //   Cell: ({ row }) => {
      //     const isCurrentSegment = row.original.segment_name?.toLowerCase() === currentSegment?.toLowerCase();
      //     return isCurrentSegment ? elapsedTime !== '00:00:00' ? `${elapsedTime}` : '' : '';
      //   },
      // },
      {
        Header: 'Accrued Time',
        accessor: 'seconds_accrued',
        Cell: ({ row, data, value }) => {
          const { segment_name, seconds_accrued } = row.original;

          if (segment_name === 'lunch') {
            // Check if there is a previous and next row
            const prevRow = data[row.index - 1];
            const nextRow = data[row.index + 1];
            if (prevRow?.time_out && nextRow?.time_in) {
              let returnedValue = calculateTimeDifference(
                prevRow?.time_out,
                nextRow?.time_in,
              );
              return returnedValue !== '-' ? formatTimeStr(returnedValue) : '-';
            }
          }
          // console.log(elapsedTime)
          const isCurrentSegment = row.original.segment_name?.toLowerCase() === currentSegment?.toLowerCase();
          const validElapsedTime = elapsedTime && typeof elapsedTime === 'string' ? elapsedTime : '';

          return segment_name?.toLowerCase() === currentSegment?.toLowerCase()
            ? seconds_accrued > 0
              ? formatTimeStr(seconds_accrued)
              : isCurrentSegment ? elapsedTime !== '00:00:00' ? `${validElapsedTime}` : '' : ''  //'In Process'
            : value > 0 && formatTimeStr(value);
        },
      },
      {
        Header: 'Time Clock',
        accessor: 'paid_time',
        Cell: ({ row, value, data }) => {
          const { segment_name, seconds_accrued } = row.original;
          let isClockedOut =
            ss_is_in === null &&
            (currentSegment?.toLowerCase() === (segment_list[0])?.toLowerCase() ||
              currentSegment?.toLowerCase() === 'clock in');
          if (segment_name === 'lunch') {
            // Check if there is a previous and next row
            const prevRow = data[row.index - 1];
            const nextRow = data[row.index + 1];
            if (prevRow?.time_out && nextRow?.time_in) {
              let returnedValue = calculateTimeDifference(
                prevRow?.time_out,
                nextRow?.time_in,
              );
              return returnedValue !== '-' && value === 1
                ? 'in'
                : 'out';
            }
          }

          // Modify to show 'in-in process' or 'out-in process' if still in process
          if (segment_name?.toLowerCase() === currentSegment?.toLowerCase()) {
            const clockStatus = value === 1 ? 'in' : 'out';
            return seconds_accrued > 0
              ? `${clockStatus}`
              : `${clockStatus} process`;
          }

          // if (segment_name?.toLowerCase() === (segment_list[segment_list?.length-1])?.toLowerCase() && isClockedOut) {
          //   return 'You have successfully clocked out';
          // }
          return segment_name?.toLowerCase() === currentSegment?.toLowerCase()
            ? value === 1
              ? 'in'
              : 'out'
            : seconds_accrued > 0 && (value === 1 ? 'in' : 'out');
        },
      },
    ],
    [currentSegment, ss_is_in, segment_list, elapsedTime, data], // Make sure the columns are re-generated when state changes
  );

  const [activeTab, setActiveTab] = useState('scheduled');

  return (
    data?.length > 0 && (
      <div className="stWidth">
        {/* <TimelineComponent data={data} scheduleData={modified_shift_data} /> */}
        <TimeLineGraph
          scheduleData={modified_shift_data}
          currentSegment={currentSegment}
          segments={data}
        />
        {currentSegment?.toLowerCase() !== 'clock in' || ss_is_in === null ? (
          <ActualTimelineNew
            data={data}
            scheduleData={modified_shift_data}
            segments={data}
          />
        ) : <></>}

        {ss_is_in === null &&
          (currentSegment?.toLowerCase() === (segment_list[0])?.toLowerCase() ||
            currentSegment?.toLowerCase() === 'clock in') ? (
          // <div className={`text-white p-lg-3 text-center bg-dark mb-2 mb-lg-5`}>
          //   <h2 className="mb-0 font-weight-bold text-white text-capitalize">
          //     you have successfully clocked out
          //   </h2>
          // </div>
          <></>
        ) : currentSegment?.toLowerCase() === 'clock in' ? (
          <div className={`text-white p-lg-3 text-center bg-dark mb-2 mb-lg-5`}>
            <h2 className="mb-0 font-weight-bold text-white">
              You are Not Clocked In
            </h2>
          </div>
        ) : (
          <div
            className={`text-white p-lg-3 text-center mb-2 mb-lg-5`}
            style={{ background: isPink ? '#E0346E' : '#6E6E6E' }}
          >
            {isPink ? (
              <h2 className="mb-0 font-weight-bold text-white">
                Clocked in to{' '}
                <span className="text-capitalize">{currentSegment}</span>
              </h2>
            ) : (
              <h2 className="mb-0 font-weight-bold text-white">
                Clocked out to{' '}
                <span className="text-capitalize">{currentSegment}</span>
              </h2>
            )}
          </div>
        )}
        <div
          className="card mb-lg-5 mx-0 px-0 h-auto"
          style={{
            borderRadius: 0,
            boxShadow:
              'rgba(17, 17, 26, 0.1) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 48px',
          }}
        >
          <div
            className="card-header d-flex justify-content-between align-items-center cursor-pointer"
            onClick={toggleVisibility}
          >
            <h5 className="mb-0">{'Shift Segment List'}</h5>
            <button className="btn btn-link p-0">
              {isVisible ? (
                <EyeOff className="mx-2" size={24} />
              ) : (
                <Eye className="mx-2" size={24} />
              )}
              {isVisible ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
            </button>
          </div>
          {isVisible && (
            <div className="card-body p-0">
              <TableComponent columns={columns} data={data} segment_list={segment_list} />
            </div>
          )}


        </div>
        {
          ss_is_in === null &&
          (currentSegment?.toLowerCase() === (segment_list[0])?.toLowerCase() ||
            currentSegment?.toLowerCase() === 'clock in') && (
            <div className={`text-white p-lg-3 text-center bg-dark mb-2 mb-lg-5`}>
              <h2 className="mb-0 font-weight-bold text-white text-capitalize">
                you have successfully clocked out
              </h2>
            </div>)
        }
        {/* dev purpose */}
        {/* <div className='mt-5'>
          <h2 className='text-red text-center mb-0 pb-0'> Dev Purpose (will be remove)</h2>
          <div className='d-flex flex-column'>
            <div>
              {modified_shift_data?.cartPrepIn && <ActualTimeline data={data} scheduleData={modified_shift_data} />}
            </div>

            <div>
              <pre>
                <title>Dev</title>
                <code>
                  {JSON.stringify(getFilteredModifiedData(modified_shift_data), null, 2)}
                </code>
              </pre>
            </div>
          </div>
        </div> */}
      </div>
    )
  );
};

export default ShiftTable;
